<template>
  <div>
    <!--西南联交所，开始-->
    <div v-if="orgid=='ins_045'" class="jigou-head-1" style="height:165px;">
      <a target="_blank" href="/">
        <img style="height:165px;" src="../../assets/jigou-1-top.png">
      </a>
    </div>
    <!--西南联交所，结束-->
    <!--省政府，开始-->
    <!--<div v-if="orgid=='ins_045'" class="jigou-head-1200" style="height:150px;">
      <a target="_blank" href="/">
        <img style="height:150px;" src="../../assets/jigou/jigou-zhengfu-top.jpg">
      </a>
    </div>-->
    <!--省政府，结束-->
    <!--省国资委，开始-->
    <!--<div v-if="orgid=='ins_045'" class="jigou-head-1560" style="height:150px;">
      <a target="_blank" href="/">
        <img style="height:150px;" src="../../assets/jigou/jigou-gzw-top.png">
      </a>
    </div>-->
    <!--省国资委，结束-->

    <!--西藏产权，开始-->
      <div class="jigou-head-1" style="height:100px;" v-else-if="orgid=='ins_099'">
        <a target="_blank" href="/">
          <img style="height:100px;" src="../../assets/jigou-2-top.png">
        </a>
      </div>
    <!--西藏产权，结束-->
    <!--河北产权，开始-->
    <div class="jigou-head-1" style="height:122px;" v-else-if="orgid=='ins_062'">
      <a target="_blank" href="/">
        <img style="height:122px;" src="../../assets/jigou-3-top.png">
      </a>
    </div>
    <!--河北产权，结束-->
    <!--重庆产权，开始-->
    <div class="jigou-head-1" style="height:124px;" v-else-if="orgid=='ins_043'">
      <a target="_blank" href="/">
        <img style="height:124px;" src="../../assets/jigou/jigou-4-top.png">
      </a>
    </div>
    <!--重庆产权，结束-->
    <!--安徽省产权交易中心，开始-->
    <div class="jigou-head-1200" style="height:175px;" v-else-if="orgid=='ins_039'">
      <a target="_blank" href="/">
        <img style="height:175px;" src="../../assets/jigou/jigou-anhui-top.png">
      </a>
    </div>
    <!--安徽省产权交易中心，结束-->
    <!--大连，开始-->
    <div class="jigou-head-1" style="height:104px;" v-else-if="orgid=='ins_038'">
      <a target="_blank" href="/">
        <img style="height:104px;" src="../../assets/jigou/jigou-dalian-top.png">
      </a>
    </div>
    <!--大连，结束-->
    <!--甘肃，开始-->
    <div class="jigou-head-1" style="height:217px;" v-else-if="orgid=='ins_008'">
      <a target="_blank" href="/">
        <img style="height:217px;" src="../../assets/jigou/jigou-gansu-top.png">
      </a>
    </div>
    <!--甘肃，结束-->
    <!--深圳，开始-->
    <div class="jigou-head-1" style="height:109px;" v-else-if="orgid=='ins_031'">
      <a target="_blank" href="/">
        <img style="height:109px;" src="../../assets/jigou/jigou-shenzhen-top.png">
      </a>
    </div>
    <!--深圳，结束-->
    <!--北部湾，开始-->
    <div class="jigou-head-1" style="height:76px;" v-else-if="orgid=='ins_005'">
      <a target="_blank" href="/">
        <img style="height:76px;" src="../../assets/jigou/jigou-beibuwan-top.png">
      </a>
    </div>
    <!--北部湾，结束-->


    <!--河南省，开始-->
    <div class="jigou-head-1" style="height:144px;" v-else-if="orgid=='ins_049'">
      <a target="_blank" href="/">
        <img style="height:144px;" src="../../assets/jigou/jigou-henansheng-top.png">
      </a>
    </div>
    <!--河南省，结束-->


    <!--河南中原，开始-->
    <div class="jigou-head-1" style="height:136px;" v-else-if="orgid=='ins_037'">
      <a target="_blank" href="/">
        <img style="height:136px;" src="../../assets/jigou/jigou-henanzhongyuan-top.png">
      </a>
    </div>
    <!--河南中原，结束-->
    <!--黑龙江联合产权，开始-->
    <div class="jigou-head-1" style="height:123px;" v-else-if="orgid=='ins_012'">
      <a target="_blank" href="/">
        <img style="height:123px;" src="../../assets/jigou/jigou-heilongjiang-top.png">
      </a>
    </div>
    <!--黑龙江联合产权，结束-->
    <!--武汉光谷，开始-->
    <div class="jigou-head-1" style="height:270px;" v-else-if="orgid=='ins_066'">
      <a target="_blank" href="/">
        <img style="height:270px;" src="../../assets/jigou/jigou-wuhanguanggu-top.png">
      </a>
    </div>
    <!--武汉光谷，结束-->
    <!--青岛，开始-->
    <div class="jigou-head-1" style="height:220px;" v-else-if="orgid=='ins_040'">
      <a target="_blank" href="/">
        <img style="height:220px;" src="../../assets/jigou/jigou-qingdao-top.png">
      </a>
    </div>
    <!--青岛，结束-->
    <!--青海，开始-->
    <div class="jigou-head-1200" style="height:211px;" v-else-if="orgid=='ins_006'">
      <a target="_blank" href="/">
        <img style="height:211px;" src="../../assets/jigou/jigou-qinghai-top.png">
      </a>
    </div>
    <!--青海，结束-->
    <!--西部，开始-->
    <div class="jigou-head-1" style="height:100px;" v-else-if="orgid=='ins_028'">
      <a target="_blank" href="/">
        <img style="height:100px;" src="../../assets/jigou/jigou-xibu-top.png">
      </a>
    </div>
    <!--西部，结束-->
    <!--新疆产权交易所，开始-->
    <div class="jigou-head-1" style="height:133px;" v-else-if="orgid=='ins_014'">
      <a target="_blank" href="/">
        <img style="height:133px;" src="../../assets/jigou/jigou-xinjiang-top.png">
      </a>
    </div>
    <!--新疆产权交易所，结束-->
    <!--山东，开始-->
    <div class="jigou-head-1" style="height:200px;" v-else-if="orgid=='ins_033'">
      <a target="_blank" href="/">
        <img style="height:200px;" src="../../assets/jigou/jigou-shandong-top.png">
      </a>
    </div>
    <!--山东，结束-->
    <!--云南，开始-->
    <div class="jigou-head-1884" style="height:81px;" v-else-if="orgid=='ins_015'">
      <a target="_blank" href="/">
        <img style="height:81px;" src="../../assets/jigou/jigou-yunnan-top.png">
      </a>
    </div>
    <!--云南，结束-->
    <!--江苏省产权交易所，开始-->
    <div class="jigou-head-1" style="height:155px;" v-else-if="orgid=='ins_010'">
      <a target="_blank" href="/">
        <img style="height:155px;" src="../../assets/jigou/jigou-jiangsu-top.png">
      </a>
    </div>
    <!--江苏省产权交易所，结束-->
    <!--江西，开始-->
    <div class="jigou-head-1" style="height:82px;" v-else-if="orgid=='ins_016'">
      <a target="_blank" href="/">
        <img style="height:82px;" src="../../assets/jigou/jigou-jiangxi-top.png">
      </a>
    </div>
    <!--江西，结束-->
    <!--广州，开始-->
    <div class="jigou-head-1" style="height:123px;" v-else-if="orgid=='ins_035'">
      <a target="_blank" href="/">
        <img style="height:123px;" src="../../assets/jigou/jigou-guangzhou-top.png">
      </a>
    </div>
    <!--广州，结束-->
    <!--沈阳，开始-->
    <div class="jigou-head-1" style="height:92px;" v-else-if="orgid=='ins_046'">
      <a target="_blank" href="/">
        <img style="height:92px;" src="../../assets/jigou/jigou-shenyang-top.png">
      </a>
    </div>
    <!--沈阳，结束-->
    <!--天津，开始-->
    <div class="jigou-head-1" style="height:110px;" v-else-if="orgid=='ins_003'">
      <a target="_blank" href="/">
        <img style="height:110px;" src="../../assets/jigou/jigou-tianjin-top.png">
      </a>
    </div>
    <!--天津，结束-->
    <!--海南，开始-->
    <div class="jigou-head-1" style="height:134px;" v-else-if="orgid=='ins_017'">
      <a target="_blank" href="/">
        <img style="height:134px;" src="../../assets/jigou/jigou-hainan-top.png">
      </a>
    </div>
    <!--海南，结束-->
    <!--福建，开始-->
    <div class="jigou-head-1" style="height:123px;" v-else-if="orgid=='ins_052'">
      <a target="_blank" href="/">
        <img style="height:123px;" src="../../assets/jigou/jigou-fujian-top.png">
      </a>
    </div>
    <!--福建，结束-->
    <!--广西，开始-->
    <div class="jigou-head-1" style="height:88px;" v-else-if="orgid=='ins_061'">
      <a target="_blank" href="/">
        <img style="height:88px;" src="../../assets/jigou/jigou-guangxi-top.png">
      </a>
    </div>
    <!--广西，结束-->
    <!--珠海，开始-->
    <div class="jigou-head-1" style="height:109px;" v-else-if="orgid=='ins_067'">
      <a target="_blank" href="/">
        <img style="height:109px;" src="../../assets/jigou/jigou-zhuhai-top.png">
      </a>
    </div>
    <!--珠海，结束-->
    <!--杭州，开始-->
    <div class="jigou-head-1" style="height:89px;" v-else-if="orgid=='ins_068'">
      <a target="_blank" href="/">
        <img style="height:89px;" src="../../assets/jigou/jigou-hangzhou-top.png">
      </a>
    </div>
    <!--杭州，结束-->
    <!--宁波，开始-->
    <div class="jigou-head-1" style="height:100px;" v-else-if="orgid=='ins_041'">
      <a target="_blank" href="/">
        <img style="height:100px;" src="../../assets/jigou/jigou-ningbo-top.jpg">
      </a>
    </div>
    <!--宁波，结束-->


<!--    轮播图，开始-->
    <div class="banner" style="margin-top:10px;">
      <swiper :options="swiperOption" v-if="banners.length>0">
        <swiper-slide v-for='img in banners' :key="img.id">
          <router-link v-if="img.imgurl==''" target="_blank" :to="{path:'/advantage',query: {id: img.id}}">
            <img :src="img.img">
          </router-link>
          <a v-else target="_blank" v-bind:title="img.title" v-bind:href="img.imgurl">
            <img :src="img.img">
          </a>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-next" slot="button-next" style="margin-top:-20px;opacity:0.3;"></div>
        <div class="swiper-button-prev" slot="button-prev" style="margin-top:-20px;opacity:0.3;"></div>
      </swiper>
    </div>
<!--    轮播图，结束-->
    <section>
      <!--v-for遍历路由-->
      <div v-bind:class="className[orgid]==undefined?'jigou-1':className[orgid]">
        <div class="nav">
          <ul>
            <li v-if="menu1">
              <!--福建的首页地址写死-->
              <a target="_blank" v-if="orgid=='ins_052'" href="https://www.fjcqjy.com/">首页</a>
              <a target="_blank" v-else href="/">首页</a>
              <!--<a target="_blank" href="http://www.swuee.com/">首页</a>-->
            </li>
            <li v-for='(m, index) in menus' :key='index'>
              <router-link :to='setPaht(m.path)'>
                <a href="javascript:void(0)">{{m.text}}</a>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  // 导入轮播图组件
  import {swiper, swiperSlide} from 'vue-awesome-swiper'
import { mapState, mapMutations } from 'vuex'
  import global from '../../components/public/Common.vue'
export default {
  name: 'apphead', // Do not use built-in or reserved HTML elements as component id
  data () {
    return {
      orgid:global.orgid,
      imgs: [],
      className:{
        'ins_045':"jigou-1",
        //'ins_045':"jigou-zhengfu",
        'ins_099':"jigou-2",
        'ins_062':"jigou-1",
        'ins_015':"jigou-yunnan",
        'ins_043':"jigou-chongqing",
        'ins_035':"jigou-guangzhou",
        'ins_038':"jigou-dalian",
      },
      searchContent: '',
      // 路由参数
      menu1:false,
      menus: [],
      banners:[],
      loadBtn:true,
      swiperOption1: {
        // pagination: '.swiper-pagination',
        // autoplay: true,
        // speed: 1000,
        // //slidesPerView : 1,//可同时显示的个数
        // //centeredSlides: true,//默认第一块居左，设置为true后居中
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // }

        loop:true,        //是否循环
        pagination: {
          el:".swiper-pagination",
          type:'bullets',
          clickable:true,
          dynamicBullets:false
        },
        speed:1000,
        autoplay: {
          delay:3000,
          disableOnInteraction:false
        },
        effect:'slide',
        navigation: {
          nextEl:'.swiper-button-next',
          prevEl:'.swiper-button-prev'
        }
      },
      swiperOption2: {
        // pagination: '.swiper-pagination',
        // autoplay: true,
        // speed: 1000,
        // //slidesPerView : 1,//可同时显示的个数
        // //centeredSlides: true,//默认第一块居左，设置为true后居中
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev',
        // }

        loop:false,        //是否循环
        pagination: {
          el:".swiper-pagination",
          type:'bullets',
          clickable:true,
          dynamicBullets:false
        },
        speed:1000,
        autoplay: {
          delay:3000,
          disableOnInteraction:false
        },
        effect:'slide',
        navigation: {
          nextEl:'.swiper-button-next',
          prevEl:'.swiper-button-prev'
        }
      }
    }
  },
  created: function () {
    let _this = this;

    //查询地区和热点标签和广告和一级菜单
    $.ajax({
      url: global.tagListUrl,
      type: 'post',
      dataType: 'jsonp',
      data: {token:global.token,"orgid":global.orgid},
      success: function (data) {
        if (data.msg == 200) {
          //第一次进页面查询广告
          _this.banners = data.result.data.ads;
          if(data.result.data.menu.menu1==1){
            _this.menu1 = true;
          }
          if(data.result.data.menu.menu2==1){
            _this.menus.push({
              text: '混改项目',
              path: '/select'
            });
          }
          if(data.result.data.menu.menu3==1){
            _this.menus.push({
              text: '项目路演',
              path: '/point'
            });
          }
          if(data.result.data.menu.menu4==1){
            _this.menus.push({
              text: '混改服务',
              path: '/author'
            });
          }
          if(data.result.data.menu.menu5==1){
            _this.menus.push();
          }
        } else {
          alert(data.msg);
        }
      },
      error: function (data) {

      }
    });
  },
  components: {
    swiper,
    swiperSlide
  },
  computed: {
    swiperOption(){
      var len = this.banners.length;
      if(len == 1){
        //只有一张广告，不滚动
        return this.swiperOption2
      }else{
        return this.swiperOption1
      }
    }
  },
  watch: {
    searchContent (curVal, oldVal) {
      if (curVal === '') {
        this.$refs.newsItem.map((item) => {
          item.style.display = 'block'
          item.className = ''
        })
      }
      if (curVal !== '') {
        this.$refs.title.map((item) => {
          if (item.innerText.match(curVal)) {
            item.parentNode.parentNode.parentNode.className = 'hightColor'
          } else {
            item.parentNode.parentNode.parentNode.style.display = 'none'
          }
        })
      }
    }
  },
  methods: {
    setPaht (path) {
      return path
    },
    setClass (classname) {
      return classname
    },
    setSrc (src) {
      return src
    },
    searchNewsBtn () {
      alert('搜索完成')
    },
    goNews () {
      this.closeSearch()
      this.clearSearchContent()
    },
    goHome () {
      this.$router.push('/select')
    },
    clearSearchContent () {
      this.searchContent = ''
    },
    ...mapMutations([
      'toggleMenu', 'openSearch', 'closeSearch'
    ])
  },
  mounted: function () {

    let _this = this;
    //查询banner
    // $.ajax({
    //   url: _this.tagListUrl,
    //   type: 'post',
    //   dataType: 'jsonp',
    //   data: {token:global.token,"orgid":global.orgid},
    //   success: function (data) {
    //     if (data.msg == 200) {
    //       delete requestSearch.start;
    //       //第一次进页面查询banner
    //       _this.banners = [];
    //     } else {
    //       alert(data.msg);
    //     }
    //   },
    //   error: function (data) {
    //
    //   }
    // });
  },
}
</script>

<style scoped>
 @import "../../style/common.css";
 @import "../../style/lb.css";
 @import "../../style/index.css";
</style>
<style lang="stylus">
.head{
  height: 60px;
  background: #262627;
  position: relative;
  img{
    height: 50px;
    position: absolute;
    top: 5px;
    right: 20%;
    cursor: pointer;
  }
  .vNews{
    height: 20px;
    top: 20px;
    left: 10px;
  }
  .baidu{
    right: 30%;
  }
  .searchBtn{
    cursor: pointer;
    color: #FFFFFF;
    position: absolute;
    top: 18px;
    right: 15%;
  }
  .aside{
    height: 60px;
    width: 60px;
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    padding-top: 1px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    .line{
      height: 1px;
      width: 25px;
      background: #fff;
      transition: all 0.5s;
    }
    .line:nth-of-type(2){
      margin: 6px 0;
    }
  }
  .closeMenu{
    .line:first-child{
      transform: rotate(45deg);
    }
    .line:nth-child(2){
      display: none;
    }
    .line:last-child{
      transform: rotate(-45deg);
    }
  }
  .searchPage{
    display: none;
    position: fixed;
    height: 100%;
    width: 100%;
    overflow: scroll;
    background: #fff;
    z-index: 999;
    .header{
      height: 60px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      padding: 0 2%;
      background: #262627;
      .search{
        height: 40px;
        width: 85%;
        border: 1px solid #eee;
        display: flex;
        justify-content: space-between;
        align-items: center;
        input{
          height: 40px;
          width: 82%;
          color: #FFFFFF;
          text-indent: 10px;
          background-color: #262627;
          outline: none;
        }
        .icon{
          color: #FFFFFF;
          margin-right: 5%;
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        }
      }
      .close{
        height: 30px;
        width: 30px;
        color: #FFFFFF;
      }
    }
  }
  .content{
    overflow: hidden;
    background-color: #FFFFFF;
    .today{
      height: 25px;
      background: #E3E4EE;
      line-height: 25px;
      text-indent: 15px;
      font-size: 14px;
    }
    .news li{
      font-size: 16px;
      margin: 15px;
      p{
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      i{
        font-size: 16px;
        font-style: normal;
        margin-right: 10px;
      }
      i.isTop3{
        color: red;
      }
      span{
        width: 90%;
        display: inline-block;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
  .hightColor{
    color: #FFFFFF;
    background-color: #EEEEEE;
  }
}

.swiper-container{
  width:1200px;
  margin:10px auto 0 auto;
  /*margin-top:10px;*/

  .swiper-wrapper {
    height: 100px;

    .swiper-slide img {
      width: 100%;
      height: 100px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/public/Head.vue